import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Documents } from "../../../models/documents/documents.model";
import { Bank } from "../../../models/bank/bank.model";
import { RootState } from "../../store";

export type PegaState = {
  Outcome: any;
  Data: {
    NextStep: string;
    Bank: Bank;
    Documents: Documents;
  };
};

const initialState: PegaState = {
  Outcome: {},
  Data: {
    NextStep: "",
    Bank: {},
    Documents: [],
  },
};

export const PegaSlice = createSlice({
  name: "pega",
  initialState,
  reducers: {
    setPega: (_pega: PegaState, action: PayloadAction<PegaState>) => {
      return { ...action.payload };
    },
  },
});

export const { setPega } = PegaSlice.actions;

export const selectStatus = (state: RootState) => state;

export default PegaSlice.reducer;
